/**
 * Tube-to-Tubesheet PDF Page 1 Component
 * 
 * Renders the first page of WPS PDF for Tubesheet welding procedures.
 * Contains:
 * - WPS header with procedure identification and company details
 * - Base Metals section (QW-403) for tubesheet applications
 * - Joint Detail section with tubesheet-specific joint configurations
 * - Technical images showing:
 *   - Tube Hole Ligament Detail
 *   - Tube Hole Detail  
 *   - Tube to Tubesheet Weld Joint Detail
 * - Filler Metals section (QW-404) for tubesheet welding
 * - Welding Procedure table with tubesheet-specific parameters
 * 
 * Specialized for tube-to-tubesheet welding with dual-column parameter support
 */

import "../Css/Download_pdf.css";
import Groove_pdf_header from "./Groove_pdf_header WPS";
import WPS_images from "./WPS_image";
import { BaseMetalTable, TubesheetDetailsTable, FillerMetalTable } from "./common";
import Tubesheet_Pdf_Fields from "./common/WPS_Tubesheet_WeldingProcedure_Json.jsx";

const TubeToTubesheet_pdf_page1 = ({
  pdf,
  page,
  previewUrl1,
  previewUrl2,
  previewUrl3
}) => {
  const type = [{ Type: pdf[0]?.wld_WPSType }];
  const Imageheaders = [
    "Tube Hole Ligament Detail",
    "Tube Hole Detail",
    "Tube to Tubesheet Weld Joint Detail"
  ];
  const images = [previewUrl1, previewUrl2, previewUrl3];
  const styles = { group: { display: "flex" } };
  const WPType = pdf[0].wld_WPSType === "Tubesheet" && Tubesheet_Pdf_Fields;  return (
    <div className="WPSMainPDF">
      {/* Table 1-Header */}
      <Groove_pdf_header page={page} pdf={pdf} />
      
      {/* Table 2-BASE METAL */}
      <div style={{ position: "relative", top: "7px" }}>
        <div style={styles.group}>
          <div className="WPSbasemetal">BASE METALS ( QW-403)</div>
        </div>
        
        <BaseMetalTable pdf={pdf} type="Tubesheet" />
        
        {/* Table 3-Joint detail */}
        <div
          className="WPSgroup"
          style={{
            align: "right",
            textAlign: "right",
            width: "50%",
          }}
        >
          <div className="WPStitle5">JOINT DETAIL</div>
        </div>
        
        <TubesheetDetailsTable pdf={pdf} type="Tubesheet" />
        
        {/* Images */}
        <WPS_images
          type={[type]}
          Imageheaders={Imageheaders}
          images={images}
          pdf={pdf}
        />
        
        {/* Table 4-Filler metals */}
        <div
          className="WPSgroup"
          style={{
            align: "right",
            textAlign: "right",
            width: "50%",
          }}
        >
          <div className="WPStitle5">FILLER METALS (QW-404)</div>
        </div>
        
        <FillerMetalTable pdf={pdf} type="Tubesheet" />
        
        {/* Table 5-Welding Procedure */}
        <div
          className="WPSgroup"
          style={{
            align: "right",
            textAlign: "right",
            width: "45%",
          }}
        >
          <div className="WPStitle5">WELDING PROCEDURE</div>
        </div>
        
        <table id="table" className="WPSTable7">
          {WPType.map((i, count) => {
            let value1 = pdf[1]?.[i.FieldName] !== "" ? pdf[1]?.[i.FieldName] : "--";
            let value2 = "";
            
            if (i.Colums == 2) {
              value1 = pdf[1]?.[i.FieldName][0];
              value2 = pdf[1]?.[i.FieldName][1];
            }
            
            const paddingleft = i.ColumnDesc !== "" ? "WPSwithLeftrcorner1" : "WPSwithoutLeftrcorner1";
            const middleLeft = i.ColumnDesc !== "" ? "WPSMidwithLefttext1" : "WPSMidwithoutLefttext1";
            const midtext = i.Suffix === "Shielding" ? (
              <span
                style={{
                  marginLeft: "26px",
                  fontFamily: "WorkSans-Regular",
                }}
              >
                {i.MiddleDesc}
              </span>
            ) : (
              <>{i.MiddleDesc}</>
            );
            
            let rowClass = "WPStrhide";
            let ThClass = "WPSthhide";
            
            if (count === 0) {
              rowClass = "WPStrFirstRow";
              ThClass = "WPSthhideFirstRow";
            }
            
            if (count == WPType.length - 1) {
              ThClass = "WPSthhideLastRow";
              rowClass = "WPStrLastRow";
            }
            
            return (
              <tr key={i.FieldName || count} className={rowClass}>
                <th className={ThClass} style={{ width: "27%" }}>
                  {i.MiddleDesc != undefined ? (
                    <div className="WPSgroup">
                      <div className="WPSlcorner">{i.ColumnDesc}</div>
                      <div className={middleLeft}>{midtext}</div>
                      <div className={paddingleft}>{i.Unit}</div>
                    </div>
                  ) : (
                    <>
                      <div className="WPSlcorner">{i.ColumnDesc}</div>
                      <div className="WPSrcorner1">{i.Unit}</div>
                    </>
                  )}
                </th>
                
                {i.Colums == 2 ? (
                  <td className="processdatatube" style={{ width: "200px" }}>
                    <div className="WPSgroup" style={{ width: "100%" }}>
                      <div className="WPStdlcorner">{value1}</div>
                      <div className="WPStdrcorner">{value2}</div>
                    </div>
                  </td>
                ) : (
                  <td className="processdatatube" style={{ width: "200px" }}>
                    {value1}
                  </td>
                )}
              </tr>
            );
          })}
        </table>
      </div>
      
      <br />
      
      <div id="footer" style={{ position: "fixed", top: "825px" }}>
        <table className="WPSfooter">
          <tr>
            <td>Page 1 of 2</td>
          </tr>
        </table>
      </div>
    </div>
  );};

export default TubeToTubesheet_pdf_page1; 
